import React from "react"

const PageSubtitle = ({ children }) => <h4>{children}</h4>

export default PageSubtitle



// WEBPACK FOOTER //
// ./src/medium/PageSubtitle.js